/**
 * 会议纪要状态
 */
export const MeetingMinuteStatus = {
    /**
     * 未开始
     */
    NOT_STARTED: 1,
    /**
     * 记录中
     */
    RECORDING: 2,
    /**
     * 暂停
     */
    PAUSED: 3,
    /**
     * 分析中
     */
    ANALYSIS: 4,
    /**
     * 结束
     */
    COMPLETED: 5,
    /**
     * 文件分析中
     */
    FILE_ANALYSIS: 6,

}